<!-- src/routes/video-v2.svelte -->
<script>
  import Button from '../components/common/Button.svelte';
  import AI_2025_03_28_Video_V2 from '../components/common/AI-2025-03-28-Video-V2.svelte';
</script>

<section class="video_page">
  <div class="content_wrapper">
    <div class="header_section">
      <h1 class="marker-font">Is your Business Getting Blindsided by AI?</h1>
      <p class="subtitle">An Overview of What Changed in less than 10 Minutes</p>
      <p class="intro">
        Get a quick overview of the 8 key AI breakthroughs reshaping business.
        This video provides a high-level summary of what changed and why it matters for your business.
      </p>
    </div>

    <div class="video_section">
      <AI_2025_03_28_Video_V2 />
    </div>

    <div class="cta_section">
      <h2>Be Among the First to Watch</h2>
      <p>Join Down to Earth Guides (free) to get early access to this video and the plain-English series.</p>
      <Button
        href="/join?topic=blindsided"
        variant="primary"
        size="large"
      >
        JOIN NOW - IT'S FREE
      </Button>
    </div>
  </div>
</section>

<style>
  .video_page {
    padding: 6rem 2rem;
    background: var(--color-background);
  }

  .content_wrapper {
    width: 100%;
    margin: 0 auto;
  }

  .header_section {
    width: 100%;
    margin: 0 auto 3rem;
    text-align: center;
  }

  h1 {
    font-size: 3.5rem;
    line-height: 1.2;
    margin-bottom: 1rem;
    color: var(--color-text);
    text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.1);
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 0 1rem;
  }

  .subtitle {
    font-size: 2rem;
    line-height: 1.3;
    margin-bottom: 2rem;
    color: var(--color-primary);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .intro {
    font-size: 1.25rem;
    line-height: 1.6;
    color: var(--color-text-muted);
    width: 100%;
    margin: 0 auto;
  }

  .video_section {
    margin: 4rem auto;
    max-width: 800px;
  }

  .cta_section {
    width: 100%;
    margin: 4rem auto 0;
    text-align: center;
    padding: 2rem;
    background: var(--color-card-bg);
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }

  .cta_section h2 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    color: var(--color-text);
  }

  .cta_section p {
    font-size: 1.1rem;
    margin-bottom: 2rem;
    color: var(--color-text-muted);
  }

  @media (max-width: 768px) {
    .video_page {
      padding: 4rem 1rem;
    }

    .header_section {
      margin-bottom: 2rem;
    }

    h1 {
      font-size: 2.5rem;
      line-height: 1.2;
      margin-bottom: 0.75rem;
    }

    .subtitle {
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }

    .intro {
      font-size: 1.1rem;
    }

    .video_section {
      margin: 2rem auto;
    }

    .cta_section {
      margin: 3rem 1rem 0;
      padding: 1.5rem;
    }

    .cta_section h2 {
      font-size: 1.5rem;
    }

    .cta_section p {
      font-size: 1rem;
    }
  }
</style> 